import React, { useEffect, useState } from "react";
import { AnimatedCard, BackgroundOverlay, Card, CardFooter, CardTitleDiv, EventType, EventTypeList } from "./elements";
import { Responsive, WidthProvider } from "react-grid-layout";
import Img from "gatsby-image";
import { H6, H6Big, H6Strong } from "../Typography";
import {
  getFormatShortDayNoTimeZone,
  getTime,
  formatTime,
  getTwoDifferenceDayFormatNoTimeZone,
  getFormatTwoShortDayNoTimeZone,
} from "../../modules/time";
import { Link } from "gatsby";

const ResponsiveGridLayout = WidthProvider(Responsive);

const EventCardList = ({ events, lg_layout, md_layout, rowHeight, spacing }) => {
  const [layouts, setLayouts] = useState(null);

  useEffect(() => {
    const layoutLg = [];
    const layoutMd = [];

    events?.forEach((item, index) => {
      if (lg_layout?.length) {
        layoutLg.push({
          ...lg_layout[index % lg_layout?.length],
          i: `${item?.id}`,
        });
      }

      if (md_layout?.length) {
        layoutMd.push({
          ...md_layout[index % md_layout?.length],
          i: `${item?.id}`,
        });
      }
    });

    setLayouts({
      lg: layoutLg,
      md: layoutMd,
    });
  }, [events]);

  const handleDate = (start, end) => {
    return new Date(start)?.getFullYear() !== new Date(end)?.getFullYear() ||
      new Date(start)?.getMonth() !== new Date(end)?.getMonth() ||
      !start ||
      !end
      ? getTwoDifferenceDayFormatNoTimeZone(start, end)
      : new Date(start)?.getDate() === new Date(end)?.getDate()
      ? getFormatShortDayNoTimeZone(start, true)
      : getFormatTwoShortDayNoTimeZone(start, end, false, " & ");
  };

  return (
    <>
      {events?.length && layouts ? (
        <ResponsiveGridLayout
          className="layout"
          breakpoints={{ lg: 1000, md: 600, sm: 0 }}
          cols={{ lg: 12, md: 8, sm: 1 }}
          isDraggable={false}
          layouts={layouts}
          rowHeight={rowHeight || 250}
          margin={[spacing || 10, spacing || 10]}
          style={{
            margin: `-${spacing || 10}px`,
          }}
        >
          {events?.map((event) => {
            const locations = event?.qafEventLocation
              ?.filter((location) => !!location?.locationId)
              .map((location) => location?.title)
              ?.join(", ");
            return (
              <AnimatedCard key={event?.id}>
                <Link to={`/event/${event?.slug}/`}>
                  <Card>
                    {event?.headerImage?.length ? (
                      <Img fixed={event?.headerImage?.[0]?.cardImage?.childImageSharp?.fixed} style={{ width: "100%", height: "100%" }} alt={`Quoz arts fest event - ${event?.title}`} />
                    ) : null}
                    <BackgroundOverlay />
                    <CardTitleDiv>
                      {event?.qafEventType?.length ? (
                        <EventTypeList>
                          {event?.qafEventType?.map((eventType, eventTypeIndex) => (
                            <EventType key={eventTypeIndex}>{eventType?.title}</EventType>
                          ))}
                        </EventTypeList>
                      ) : null}
                      <H6Big>{event?.title}</H6Big>
                    </CardTitleDiv>
                    <CardFooter>
                      {event?.eventStartDateTime || event?.eventEndDateTime ? (
                        <H6Strong>{handleDate(event?.eventStartDateTime, event?.eventEndDateTime)}</H6Strong>
                      ) : null}

                      {event?.eventStartDateTime || event?.eventEndDateTime ? (
                        <H6 className="mid" style={{ marginBottom: "10px" }}>
                          {event?.eventStartDateTime ? formatTime(getTime(event?.eventStartDateTime)) : null}
                          {event?.eventStartDateTime && event?.eventEndDateTime ? "-" : null}
                          {event?.eventEndDateTime ? formatTime(getTime(event?.eventEndDateTime)) : null}
                        </H6>
                      ) : null}

                      {locations ? <H6Strong className="mid">{locations}</H6Strong> : null}
                    </CardFooter>
                  </Card>
                </Link>
              </AnimatedCard>
            );
          })}
        </ResponsiveGridLayout>
      ) : null}
    </>
  );
};

export default EventCardList;
